const Company = {
  build,
};

function build() {
  return {
    __typename: "Company",
    name: "",
  };
}

export default Company;
